import styled from "styled-components"
import { ButtonStyles } from "./ButtonStyles"

export const ButtonA = styled.a`
    ${ButtonStyles};
`;